import { useEffect, useMemo, useState } from "react";
import countryCodes  from "../../Utils/countryCodes.json";
import { DonorService } from "../../Services/Donor.Service";
import { useNavigate } from "react-router-dom";
import { Dropdown, Form as BootstrapForm } from "react-bootstrap";
function SmsAlertsMoobileCongifuration({userData, setToastMessage, setToastVariant, setShowToast, setLoading, fetchProfile}) {

    const [isShowMobileEdit, setIsShowMobileEdit] = useState(false);

     
    const [countryCode, setCountryCode] = useState("+1");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setError] = useState("");
    const [countrySearch, setCountrySearch] = useState("");

    const [isSmsAlertChecked, setIsSmsAlertChecked] = useState(false);


    useEffect(() => {
        setIsSmsAlertChecked(userData?.is_sms_allowed === '1');
        if (userData?.sms_alert_number) {
            const pn = userData.sms_alert_number.trim();

            // Extract digits
            const digits = pn.replace(/\D/g, "");

            // country code -> between + and the start of phone number
            let cc = "+1"; 
            let numberPart = digits;

            // If starts with +, detect country code
            if (pn.startsWith("+")) {
                // Try up to 3-digit country code
                const knownCodes = ["1", "44", "91"]; //  expand later
                let found = knownCodes.find(code => digits.startsWith(code));

                if (found) {
                    cc = `+${found}`;
                    numberPart = digits.slice(found.length);
                }
            }

            // Update state
            setCountryCode(cc);
            setPhoneNumber(numberPart);
        }
    }, [userData]);

    const phoneMaxLength = 15; // E.164 max length (digits only)

    const formatPhone = (num) => {
        return num
            .replace(/\D/g, "") // keep digits only
            .slice(0, phoneMaxLength);
    };

    // // Format while typing 
    // const handlePhoneChange = (e) => {
    //     let digits = e.target.value.replace(/\D/g, "");

    //     // Limit to 11 digits including country code (1)
    //     digits = digits.slice(0, 11);

    //     const cc = digits.substring(0, 1);
    //     const p1 = digits.substring(1, 4);
    //     const p2 = digits.substring(4, 7);
    //     const p3 = digits.substring(7, 11);

    //     let formatted = "+";
    //     if (cc) formatted += cc;
    //     if (p1) formatted += ` (${p1})`;
    //     if (p2) formatted += ` ${p2}`;
    //     if (p3) formatted += `-${p3}`;

    //     setPhone(formatted);

    //     if (digits.length < 11) {
    //         setError("Please enter a valid 10-digit number.");
    //     } else {
    //         setError("");
    //     }
    // };
    const handlePhoneInput = (e) => {
        const formatted = formatPhone(e.target.value);
        setPhoneNumber(formatted);

        if (!formatted) {
            setError("Phone number is required");
        } else if (formatted.length < 10) {
            setError("Enter a valid phone number");
        } else {
            setError("");
        }
    };
    const updateMobile = async () => {
        if (!phoneNumber) {
            setError("Phone number is required");
            return;
        }
        if (error) return;
        const finalNumber = `${countryCode}${phoneNumber}`;

        const payload = {
            user_id: userData.id,
            phone_number: finalNumber, // only digits
            is_sms_allowed: isSmsAlertChecked ? 1 : 0
        };

        try {
            const response = await DonorService.updateSmsAlerts(payload);
            console.log("Response:", response);
            setToastMessage(response.message);
            setToastVariant("success");
            setShowToast(true);
            setLoading(false);
            fetchProfile();
            // alert("Mobile number updated successfully!");

            setIsShowMobileEdit(false); // close edit UI after save
        } catch (err) {
            console.error("Error updating mobile:", err);
            setLoading(false);
            setToastMessage(err.message);
            setToastVariant("error");
            setShowToast(true);
            setError("Failed to update SMS preferences");
        }
    };
    const navigate = useNavigate();

    const filteredCountries = useMemo(() => {
        return countryCodes.filter((country) => {
            const label = `${country.flag} +${country.phone}`;
            return label.toLowerCase().includes(countrySearch.toLowerCase());
        });
    }, [countrySearch]);

    const selectedCountry = useMemo(() => {
        return countryCodes.find((country) => `+${country.phone}` === countryCode);
    }, [countryCode]);
    return (
        <>
            <div className="el-bg-table el-super-admin mt-3">
                <div>
                    <p className="mb-1"><b>{userData.display_name}</b></p>
                    <p className="mb-0"><b>Email Address:</b> {userData.email}</p>
                    <p className="mb-0"><b>Mobile:</b> {userData.sms_alert_number} <button type="button" onClick={()=>{setIsShowMobileEdit(!isShowMobileEdit)}} className="back-link ms-2">(edit)</button></p>
                </div>
            </div>
            {isShowMobileEdit &&
            <div className="el-bg-table el-super-admin mt-3">
                <div>
                    <p><b>Receive SMS Alerts & Contact Information for deliveries</b></p>
                    <p className="mt-2">Your cell phone is required to receive real-time delivery information of your samples.</p>
                    <div>
                        <label className="mb-1">Mobile Phone Number</label>
                         <div className="d-flex gap-2 mb-1">
                                <Dropdown className="w-25 sms-alert-mobile-config">
                                    <Dropdown.Toggle
                                        variant="light"
                                        className="w-100 text-start form-control"
                                    >
                                        {selectedCountry ? `${selectedCountry.flag} +${selectedCountry.phone}` : "Select Code"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                        <div className="px-2 py-2">
                                            <BootstrapForm.Control
                                                type="text"
                                                placeholder="Search..."
                                                value={countrySearch}
                                                onChange={(e) => setCountrySearch(e.target.value)}
                                            />
                                        </div>
                                        <Dropdown.Divider />
                                        {(countrySearch ? filteredCountries : countryCodes).map((country) => (
                                            <Dropdown.Item
                                                key={country.code}
                                                onClick={() => {
                                                    setCountryCode(`+${country.phone}`);
                                                    setCountrySearch("");
                                                }}
                                            >
                                                {country.flag} +{country.phone}
                                            </Dropdown.Item>
                                        ))}
                                        {filteredCountries.length === 0 && countrySearch && (
                                            <p className="px-3 text-muted mb-0">No results</p>
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>

                                <input
                                    className="form-control w-50"
                                    type="tel"
                                    maxLength={10}
                                    placeholder="Enter phone number"
                                    value={phoneNumber}
                                    onInput={handlePhoneInput}
                                />
                        </div>
                         {error && <div className="text-danger">{error}</div>}
                    </div>
                    <div className="d-flex mt-2">
                        <div>
                            <input  id="smsAlertCheckbox" className="confirmInfoCheckbox" type="checkbox" checked={isSmsAlertChecked} onChange={() => setIsSmsAlertChecked(prev => !prev)} />
                        </div>
                        <div className="ms-2">
                        <label htmlFor="smsAlertCheckbox" >By providing your phone number, you consent to receive SMS notifications from Donor X. Messages may include Jobs You Qualify For, Appointment Reminders, and Payment Notifications. Message and data rates may apply. You can unsubscribe by unchecking this box. For more information, see our
                    </label>
                            <a className="terms-privacy-link" href="/policies/term-of-use" target="_blank" rel="noreferrer" > Terms of Use </a>
                            {/* onClick={(e)=>{e.preventDefault();navigate("/policies/term-of-use")}} */}
                            +
                            <a className="terms-privacy-link" href="/policies/donorx-llc" target="_blank" rel="noreferrer"> Privacy Policy</a>
                             {/* onClick={(e)=>{e.preventDefault();navigate("/policies/donorx-llc")}} */}
                            .
                        </div>
                    </div>
                     <div className="d-flex align-items-center mt-3">
                        <button onClick={updateMobile} className="el-main-button me-3">
                        <span>Save</span>
                        </button>
                    </div>
                </div>
            </div>
            }
        </>
    )
}
export default SmsAlertsMoobileCongifuration;